import {createUseStyles} from 'react-jss';
import {Theme} from './themes/default';

const useAgeGateStyles = createUseStyles((theme: Theme) => {
        return {
            container: {
                padding: theme.spacing(5),
                textAlign: 'center',
                backgroundColor: '#D1A85E',
                marginTop: '12vh',
                minHeight: '495px',
                [theme.breakpoints.down('lg')]:{
                    marginTop: '15vh',
                    padding: theme.spacing(3),
                }
            },
            circularProgress: {
                background: 'aqua',
                border: '1px solid red'
            },
            formWrapper: {
                backgroundColor: '#E3CB9E',
                padding: theme.spacing(5),
                height: '100%',
                [theme.breakpoints.down('lg')]:{
                    padding: theme.spacing(3),
                }
            },
            formTitle: {
                fontFamily: 'PoplarKozel, sanserif',
                color: '#413121',
                fontSize: 'max(3vh, 3vw)',
                textTransform: 'uppercase',
                lineHeight: '1.2',
                marginBottom: '5vh',
                [theme.breakpoints.down('lg')]: {
                    marginBottom: '3vh',
                    fontSize: '3.5vh',
                }
            },
            formSubTitle: {
                fontFamily: 'PoplarKozel, sanserif',
                color: '#413121',
                fontSize: 'max(2.5vh, 2.5vw)',
                textTransform: 'uppercase',
                lineHeight: '1.2',
                marginBottom: '3vh',
                [theme.breakpoints.down('lg')]: {
                    fontSize: '2.5vh',
                }
            },
            formInput: {
                fontFamily: 'PoplarKozel, sanserif',
                color: '#413121',
                fontSize: 'max(5vh,5vw)',
                lineHeight: '1',
                padding: 0,
                '& input': {
                    fontFamily: 'PoplarKozel, sanserif',
                    textAlign: 'center',
                    fontSize: 'max(5vh,5vw)',
                    padding: 0,
                    [theme.breakpoints.down('lg')]: {
                        fontSize: '5vh',
                    }
                },
                [theme.breakpoints.down('lg')]: {
                    fontSize: '5vh',
                }
            },
            formSubmit: {
                fontFamily: 'PoplarKozel, sanserif',
                color: '#413121',
                fontSize: '2vh',
                backgroundColor: '#D1A85E',
                paddingTop: '2vh',
                paddingBottom: '2vh',
                width: '100%',
                textTransform: 'uppercase',
                lineHeight: '1',
                marginTop: '3vh',
            },
            checkboxKeepIt: {
                fontFamily: theme.typography.fontFamily,
                fontSize: 'max(1.5vh,1.5vw)',
                color: '#413121',
                marginTop: '2vh',
                '& span': {
                    fontSize: 'max(1.5vh,1.5vw)',
                    '@media (min-width: 720px)': {
                        fontSize: '1.5vh',
                    }
                },
                '& .MuiCheckbox-root': {
                    margin: 0,
                },
                '@media (min-width: 720px)': {
                    fontSize: '1.5vh',
                },
            },
            textCookie: {
                fontFamily: theme.typography.fontFamily,
                fontSize: 'max(1.5vh,1.5vw)',
                color: '#413121',
                '@media (min-width: 720px)': {
                    fontSize: '1.5vh',
                }
            },
            textPolicy: {
                fontFamily: theme.typography.fontFamily,
                fontSize: 'max(1.5vh,1.5vw)',
                color: '#413121',
                '@media (min-width: 720px)': {
                    fontSize: '1.5vh',
                }
            },
            goatGif: {
                maxWidth: '300px',
                width: '100%',
                marginTop: 'min(-25vh,-25vw)',
                maxHeight: '350px',
                height: 'auto',
                '@media (min-width: 720px)': {
                    fontSize: '1.5vh',
                    marginTop: '-25vh',
                }
            },
            footer: {
                padding: theme.spacing(3),
                height: '10vh',
            },
        }
    }
);

export default useAgeGateStyles;
